<template>
  <div v-if="show"
       class="product-glance">
    <div class="product-glance__heading">
      {{ heading }}
    </div>

    <dl>
      <product-glance-row
        v-if="ageRanges && ageRanges.length"
        category="Age ranges"
        :icon="['fal', 'user-friends']"
        :values="ageRanges"></product-glance-row>

      <product-glance-row
        v-if="areasCovered && areasCovered.length"
        category="Areas covered"
        :icon="['fal', 'clock']"
        :values="areasCovered"></product-glance-row>

      <product-glance-row
        v-if="testDuration && testDuration.length"
        category="Test duration"
        :icon="['fal', 'clock']"
        :values="testDuration"></product-glance-row>

      <product-glance-row
        v-if="testFormat && testFormat.length"
        category="Test format"
        :icon="['fal', 'tablet']"
        :values="testFormat"></product-glance-row>

      <product-glance-row
        v-if="contact && contact.length"
        category="Contact"
        :icon="['fal', 'envelope']"
        :values="contact"></product-glance-row>
    </dl>
  </div>
</template>

<script>
import ProductGlanceRow from "~/Components/Products/ProductGlanceRow.vue";

export default {
  name: "ProductGlance",
  components: {
    ProductGlanceRow,
  },
  props: {
    heading: {
      type: String,
      default: "At a glance",
    },
    ageRanges: {
      type: Array,
      default: null,
    },
    areasCovered: {
      type: Array,
      default: null,
    },
    testDuration: {
      type: Array,
      default: null,
    },
    testFormat: {
      type: Array,
      default: null,
    },
    contact: {
      type: Array,
      default: null,
    },
  },
  computed: {
    show () {
      return (
        ( this.ageRanges && this.ageRanges.length )
        || ( this.areasCovered && this.areasCovered.length )
        || ( this.testDuration && this.testDuration.length )
        || ( this.testFormat && this.testFormat.length )
        || ( this.contact && this.contact.length )
      );
    },
  },
};
</script>

<style lang="less" scoped>
.product-glance {
  &__heading {
    color: #aaa;
    font-weight: 500;
    font-size: 1.25rem;
    margin-left: 100px;
    margin-bottom: 10px;
    text-transform: uppercase;

    &::before {
      content: "";
      display: block;
      width: 50px;
      height: 4px;
      background-color: #aaa;
      margin-bottom: 10px;
    }
  }
}
</style>
